import { render, staticRenderFns } from "./ItemsRentGroupTable.vue?vue&type=template&id=6473a5de&scoped=true&"
import script from "./ItemsRentGroupTable.vue?vue&type=script&lang=js&"
export * from "./ItemsRentGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemsRentGroupTable.vue?vue&type=style&index=0&id=6473a5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473a5de",
  null
  
)

export default component.exports